import api from '@/api'
import Multiselect from 'vue-multiselect'
import { mapGetters } from 'vuex'
import datepicker from 'vuejs-datepicker'
import moment from 'moment'
import ticket3TicketManagementApi from '@/api/ticket3/ticket-management'
import { priorityOptions, moodOptions } from '@/constants/ticket3/ticketConstant'
import ticketMixin from '@/mixins/ticketMixin'
import WrapUpInput from './WrapUpInput/index.vue'
import { PAGE_GROUP } from '@/constants/page.js'
export default {
  mixins: [ticketMixin],
  props: {
    value: {
      default: null
    },
    loading: {
      default: false
    },
    livechat: {
      default: false
    },
    type: {
      default: 'edit'
    },
    varient: {
      type: String,
      default: 'dialog'
    },
    hideEditButton: {
      type: Boolean,
      default: false
    },
    showCloseButton: {
      type: Boolean,
      default: false
    }
  },
  components: {
    Multiselect,
    datepicker,
    WrapUpInput
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      agentGroup: 'getAgentGroup',
      loadingAgentGroup: 'getLoadingAgentGroup',
      agentSubGroup: 'getAgentSubgroup',
      loadingAgentSubGroup: 'getLoadingAgentSubgroup',
      agents: 'getAgent',
      loadingAgent: 'getLoadingAgent',
      isCustomerSupportService: 'isCustomerSupportService',
      customerStatusOptions: 'customerStatusOptions'
    }),
    saleForm: {
      get() {
        try {
          const {
            sale_type_status,
            event_name,
            event_value,
            event_currency,
            is_send_event_to_facebook
          } = this.ticket

          return {
            type: sale_type_status || '',
            eventName: event_name || 'Purchase',
            amount: event_value || '',
            currency: event_currency || this.selectedBot.ticket_v3_config.default_currency || 'THB',
            isSendToMeta: is_send_event_to_facebook || false
          }
        } catch (error) {
          return undefined
        }
      },
      set(value) {
        this.ticket = {
          ...this.ticket,
          sale_type_status: value.type,
          event_name: value.eventName,
          event_value: value.amount,
          event_currency: value.currency,
          is_send_event_to_facebook: value.isSendToMeta
        }
      }
    },
    statusOptions() {
      if (this.isCustomerSupportService) {
        return this.customerStatusOptions
      } else {
        const status = this.$store.getters.ticketStatusOptions
        if ([PAGE_GROUP.EMMA_CLINIC].includes(this.selectedBot.page_group)) {
          const statusFilter = status.filter((item) =>
            ['pending', 'answered', 'cancelled', 'cancelled by customer'].includes(item.value)
          )
          const index = 2
          const statusOption = [
            ...statusFilter.slice(0, index),
            { label: 'closed', value: 'closed', color: '#e0e0e0' },
            ...statusFilter.slice(index)
          ]
          return statusOption
        } else {
          return status
        }
      }
    },
    customerSupportServiceSurveyList() {
      const { closed_with_survey_message } = this.selectedBot.ticket_v3_config
      return closed_with_survey_message
    },
    isShowCustomerSupportServiceSurvey() {
      return this.isCustomerSupportService && this.surveyList && this.surveyList.length > 0
    }
  },
  data() {
    return {
      ticket: {
        userid: null,
        firstname: null,
        lastname: null,
        group: null,
        subgroup: null,
        subject: null,
        details: null,
        assignedTo: null,
        channel: null,
        status: 'pending',
        priority: null,
        duedate: null,
        tags: null,
        contact_firstname: null,
        contact_lastname: null,
        contact_salary: null,
        contact_occupation: null,
        contact_phone: null,
        contact_email: null,
        mood: null,
        comment: null,
        wrap_up: null,
        wrap_up_route: null
      },
      moodOptions: moodOptions,
      showManage: false,
      search: '',
      loadingTicket: false,
      items: [],
      select: null,
      groupOptions: [],
      subGroupOptions: [],
      tags: [],
      tagssearch: null,
      tagitems: [{ header: 'Select an option or create one' }],
      tagediting: null,

      priority: {
        text: 'Medium',
        value: 'medium'
      },
      priorityOptions: priorityOptions,
      appOptions: ['', 'phone', 'email', 'website', 'others'],

      duedate: {
        start: null,
        starttime: null
      },

      showDueDate: false,
      showDueTimeDialog: false,
      autocompleteTimestamp: moment().valueOf(),
      filterSubGroup: [],
      filterAgents: [],
      wrap_up_route: [],
      saleFormTimestamp: Date.now(),
      surveyList: [],
      closed_with_survey_message: null
    }
  },
  async mounted() {
    this.handleInitTicket()
    this.cached_ticket = JSON.stringify(this.ticket)
    this.surveyList = this.customerSupportServiceSurveyList
    const isDefaultSurvey = this.customerSupportServiceSurveyList.find((item) => item.is_default)
    this.closed_with_survey_message =
      this.ticket.closed_with_survey_message ||
      isDefaultSurvey ||
      this.customerSupportServiceSurveyList[0]
  },
  watch: {
    search(val) {
      val && val !== this.select && this.querySelections(val)
    },
    tags(val, prev) {
      if (val.length === prev.length) return

      this.tags = val.map((v) => {
        if (typeof v === 'string') {
          v = {
            text: v
          }

          this.tagitems.push(v)
        }

        return v
      })
    },
    value: function (newVal, oldVal) {
      if (newVal != oldVal) {
        this.handleInitTicket()
      }
    }
  },
  methods: {
    handleUpdateWrapData(data) {
      this.wrap_up_route = data
    },
    handleFilterSubGroup() {
      if (this.ticket.assigngroupid) {
        this.filterSubGroup = this.agentSubGroup.filter((el) => {
          return el.admingroupid == this.ticket.assigngroupid
        })
      } else {
        this.filterSubGroup = []
      }
    },
    handleFilterAgents() {
      if (this.ticket.assigngroupid) {
        let agents = this.agents.filter((el) => {
          return el.admingroupid == this.ticket.assigngroupid
        })
        if (this.ticket.assignsubgroupid) {
          agents = agents.filter((el) => {
            return el.adminsubgroupid == this.ticket.assignsubgroupid
          })
        }
        this.filterAgents = agents
      } else {
        this.filterAgents = this.agents ? this.agents : []
      }
    },
    async handleInitTicket() {
      if (this.value) {
        this.ticket = {
          ...this.value,
          id: this.value.id,
          userid: this.value.userid,
          firstname: this.value.first_name,
          lastname: this.value.last_name,
          group: null,
          subgroup: null,
          subject: this.value.subject,
          details: this.value.details,
          assignedTo: null,
          channel: this.value.channel,
          status: this.value.status,
          priority: this.value.priority,
          duedate: this.value.duedate,
          tags: this.value.tags,
          contact_firstname: this.value.contact_firstname,
          contact_lastname: this.value.contact_lastname,
          contact_phone: this.value.contact_phone,
          contact_email: this.value.contact_email,
          mood: this.value.mood,
          comment: this.value.comment,
          wrap_up: this.value.wrap_up,
          wrap_up_route: this.value.wrap_up_route
        }
        if (this.value.duedate) {
          this.duedate.start = this.value.duedate
          this.duedate.starttime = moment(this.value.duedate).format('HH:mm')
        }
        await this.$nextTick()

        this.wrap_up_route = this.handleTicketToWrapUpRoute(this.ticket)

        this.handleFilterSubGroup()
        this.handleFilterAgents()
        await this.$nextTick()

        if (this.value.priority) {
          this.priority = this.priorityOptions.find((el) => {
            return el.value == this.value.priority
          })
        }

        try {
          if (this.value.tags) {
            var tags = this.value.tags.split(',')
            this.tags = tags.map((el) => {
              return { text: el }
            })
          }
        } catch (error) {
          console.error(error)
        }
      } else {
        const group = this.agentGroup.find((el) => {
          return el.groupname == 'Agent'
        })
        // console.log(this.value);
        if (group) this.$set(this.ticket, 'group', group)
      }

      this.saleFormTimestamp = Date.now()
    },
    checkObject(item) {
      return typeof item !== 'object'
    },
    onAssignInput(val) {
      if (val) {
        this.ticket.group = this.agentGroup.find((el) => el.id == val.admingroupid)
        this.ticket.subgroup = this.agentSubGroup.find((el) => el.id == val.adminsubgroupid)
      }
    },
    onSelectedDueDate: function (value) {
      var vm = this

      if (moment(this.duedate.end).isBefore(value)) {
        this.duedate.end = value
      }
      vm.duedate.start = value
      vm.showDueDate = false
    },
    async onChangeGroup() {
      this.ticket.assignsubgroupid = null
      this.ticket.assignadminid = null
      this.handleFilterSubGroup()
      this.handleFilterAgents()
      await this.$nextTick()
      this.autocompleteTimestamp = moment().valueOf()
    },

    async onChangeSubGroup() {
      this.ticket.assignadminid = null
      this.handleFilterSubGroup()
      this.handleFilterAgents()
      await this.$nextTick()
      this.autocompleteTimestamp = moment().valueOf()
    },
    async openModal() {
      this.showManage = true
      this.loadingTicket = true
      if (this.type == 'add') this.items = await this.getLoadUsers()
      this.loadingTicket = false
    },
    saveTicket(data) {
      return new Promise((resolve, reject) => {
        var request = data

        api.ticket2CreateTicket(request, function (error, response) {
          if (error) {
            reject(error)
          }
          resolve(response)
        })
      })
    },
    editTicket(data) {
      return ticket3TicketManagementApi.putTicketManagement({ data })
    },
    onCancel() {
      this.showManage = false
      this.ticket = JSON.parse(this.cached_ticket)
      this.select = null
      this.$emit('onClose')
    },
    addUserManual(data) {
      return new Promise((resolve, reject) => {
        var request = data
        api.postUsersmanual(request, function (error, response) {
          if (error) {
            reject(error)
          }
          resolve(response)
        })
      })
    },
    editUserManual(data) {
      return new Promise((resolve, reject) => {
        var request = {
          data: data,
          params: {
            pageid: data.pageid,
            userid: data.userid
          }
        }
        api.putUsersmanual(request, function (error, response) {
          if (error) {
            reject(error)
          }
          resolve(response)
        })
      })
    },

    async onSave() {
      let result = await this.$validator.validateAll()
      let saleForm = this.$refs.saleForm ? this.$refs.saleForm.validate() : true
      if (!result || !saleForm) {
        // do stuff if not valid.
        this.goToErrorInput()
        return false
      }
      this.loadingTicket = true
      try {
        var data = {
          assigngroupid: this.ticket.group ? this.ticket.group.id : null,
          assignsubgroupid: this.ticket.subgroup ? this.ticket.subgroup.id : null,
          assignadminid: this.ticket.assignedTo ? this.ticket.assignedTo.adminid : null
        }

        const currentTags = this.tags.map((el) => {
          return el.text
        })

        const ticketData = {
          ...this.ticket,
          ...data,
          page_id: this.selectedBot.pageid, // required
          id: this.ticket.id, // required
          priority: this.ticket.priority,
          status: this.ticket.status,
          subject: this.ticket.subject,
          details: this.ticket.details,
          contact_firstname: this.ticket.contact_firstname,
          contact_lastname: this.ticket.contact_lastname,
          contact_email: this.ticket.contact_email,
          contact_phone: this.ticket.contact_phone,
          mood: this.ticket.mood,
          comment: this.ticket.comment,
          duedate: this.duedate.start
            ? moment(this.duedate.start).format('YYYY-MM-DD ') +
              (this.duedate.starttime ? this.duedate.starttime : '00:00')
            : null,
          ...this.formatTicketData(this.ticket),
          tags: currentTags.join(','),

          ...this.handleFormatWrapUpRouteToSave(this.wrap_up_route)
          // wrap_up: this.ticket.wrapup,
          // wrap_up_route: this.ticket.wrapuproute,
        }
        if (this.type == 'add') {
          if (!this.ticket.userid) {
            var request = {
              ...data,
              ...this.ticket,
              pageid: this.selectedBot.pageid,
              first_name: this.ticket.firstname,
              last_name: this.ticket.lastname,
              phoneno: this.ticket.contact_phone,
              address: this.ticket.contact_email
            }

            // Add manual ticket
            var responseUser = await this.addUserManual(request)
            if (responseUser.data && responseUser.data.length > 0)
              this.$set(this.ticket, 'userid', responseUser.data[0].id)
          } else if (this.ticket.userid) {
            ticketData.user_id = this.ticket.userid
            var responseTicket = await this.saveTicket(ticketData)
            if (responseTicket.data && responseTicket.data.length > 0) {
              this.$emit('addTicket', responseTicket.data[0])
            }
          }
        } else {
          // Edit ticket
          ticketData.user_id = this.ticket.userid
          if (
            this.isShowCustomerSupportServiceSurvey &&
            this.closed_with_survey_message &&
            ['closed with survey'].includes(ticketData.status)
          ) {
            if (['closed with survey'].includes(JSON.parse(this.cached_ticket).status)) {
              await this.$swal.fire({
                type: 'error',
                title: this.$t('customer_support_service.please_change_the_status')
              })
              this.loadingTicket = false
              return
            }
            ticketData.closed_with_survey_message = this.closed_with_survey_message
          }
          const responseTicket = await this.editTicket(ticketData)
          if (responseTicket.status == 200 || responseTicket.status == 204) {
            this.$emit('editTicket', ticketData)
          }
        }
        this.showManage = false
        this.$emit('onClose')
        this.cached_ticket = JSON.stringify(this.ticket)
        this.select = null
      } catch (error) {
        console.error(error)
      }
      this.loadingTicket = false
    },

    onChangeSelect(val) {
      if (val) {
        this.$set(this.ticket, 'userid', val.id)
        this.$set(this.ticket, 'contact_firstname', val.first_name)
        this.$set(this.ticket, 'contact_lastname', val.last_name)
        this.$set(this.ticket, 'contact_email', val.email)
        this.$set(this.ticket, 'contact_phoneno', val.phoneno)
        this.$set(this.ticket, 'channel', val.channel)
      }
    },
    onClearCustomer() {
      this.select = null
      this.$set(this.ticket, 'userid', null)
      this.$set(this.ticket, 'contact_firstname', null)
      this.$set(this.ticket, 'contact_lastname', null)
      this.$set(this.ticket, 'contact_email', null)
      this.$set(this.ticket, 'contact_phoneno', null)
      this.$set(this.ticket, 'channel', null)
    },
    async querySelections() {
      this.loadingTicket = true
      this.items = await this.getLoadUsers()
      this.loadingTicket = false
    },
    getLoadUsers: function () {
      let vm = this
      return new Promise((resolve, reject) => {
        let data = {
          pageid: vm.selectedBot.pageid,
          filter: {
            fullname: vm.search
          },
          limit: 100,
          offset: 0
        }

        api.getAllUsers(data, function (error, response) {
          if (error) {
            reject(error)
          }

          var users = response.data
          resolve(users)
        })
      })
    },
    tagsedit(index, item) {
      if (!this.tagediting) {
        this.tagediting = item
        this.index = index
      } else {
        this.tagediting = null
        this.index = -1
      }
    },
    tagsfilter(item, queryText, itemText) {
      if (item.header) return false

      const hasValue = (val) => (val != null ? val : '')

      const text = hasValue(itemText)
      const query = hasValue(queryText)

      return text.toString().toLowerCase().indexOf(query.toString().toLowerCase()) > -1
    },
    handleSelectSurvey(index) {
      this.closed_with_survey_message = this.surveyList[index]
    },
    handleEditSurvey(data, index) {
      this.$set(this.surveyList, index, data)
      this.closed_with_survey_message = this.surveyList[index]
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/view/ticket3/ticket-management/TicketEdit.js